import delay from 'lodash/delay'

import { Section, ShowMoreText } from 'components'
import { StyledDescriptionText } from 'containers/public-listing/styled'
import { EVENT_NAME } from 'pages/[slug]'
import { useSelector } from 'store'
import { selectPublicListingPropertyDescription } from 'store/public-listing'

export const ListingOverviewSection = () => {
  const description = useSelector(selectPublicListingPropertyDescription)

  const postMessage = (message: IframeMessage<null>) => {
    window.parent.postMessage(message, '*')
  }
  return (
    <Section title="Overview">
      <ShowMoreText
        line={8}
        lineOffset={6}
        mLine={13}
        mLineOffset={11}
        onToggleDescription={() => {
          postMessage({ eventName: EVENT_NAME.ON_TOGGLE, payload: null })
        }}
        onReady={() => delay(postMessage, 500, { eventName: EVENT_NAME.ON_READY })}
      >
        <StyledDescriptionText>{description}</StyledDescriptionText>
      </ShowMoreText>
    </Section>
  )
}
